import request from '@/utils/request'

// 文件上传
export function uploadFile(data) {
    return request({
      url: '/common/uploadCommonFile',
      method: 'post',
      data: data,
      timeout: 300000
    })
  }
  export function uploadAndBpm(data) {
    return request({
      url: '/common/uploadAndBpm',
      method: 'post',
      data: data,
      timeout: 300000
    })
  }
  
//倒计时
export function timeCountDown(date, callback = () => {}){
  var time = '';
  const formatNumber = (n)=>{
    n = n.toString();
    return n[1] ? n : '0' + n;
  };
  const setTime = ()=>{
    const leftTime = new Date(date.replace(/\-/g, '/')) - new Date();
    if (leftTime >= 0) {
      const d = Math.floor(leftTime / 1000 / 60 / 60 / 24),
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24),
        m = Math.floor(leftTime / 1000 / 60 % 60),
        s = Math.floor(leftTime / 1000 % 60);
      time = `${ d > 0 ? d + ' 天 ' : '' }${ [h, m, s].map(formatNumber).join(' : ') }`;
      callback(time, () => clearInterval(timer));
    } else {
      //time = '已超时'
      time = this.$t('view.已超时');
      callback(time, () => clearInterval(timer));
      return
    }
  };
  const timer = setInterval(() => {
    setTime()
  }, 1e3);
}
// 阿拉伯数字转大写
export function arabicToChinese(num) {
  const numStr = num.toString();
  const digitArr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const unitArr = ['', '十', '百', '千', '万', '亿'];
  let chineseStr = '';

  for (var i = 0; i < numStr.length; i++) {
    var digit = Number(numStr[i]);
    var unit = unitArr[numStr.length - i - 1];
    chineseStr += digitArr[digit] + unit;
  }

  chineseStr = chineseStr.replace(/零./g, '零').replace(/零+/g, '零').replace(/零$/, '');
  chineseStr = chineseStr.replace(/^一十/, '十');

  return chineseStr;
}


// 字典项回显
export function getStatus(list,val,type){
  // type 对应需要回显的字段
  let a= ''
  type=type?type:'dictLabel'
  this[list].map(e=>{if(e.dictValue==val)a=e[type]})
  return a
}

// 附件查看与下载
export function handleViewFile(filePath, fileName) {
  const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
  if (ext == 'pdf' || 'PDF') {
    window.open(filePath, "_blank");
  } else {
    const eLink = document.createElement("a");
    eLink.download = fileName;
    eLink.style.display = "none";
    eLink.href = filePath;
    document.body.appendChild(eLink);
    eLink.click();
    eLink.remove()
  }
}
export function getStatusLabel(list,value) {
  let data= list.find(data=>data.value==value);
  return data?data.label:value;
}
